export enum NavBarLogoPosition {
    Left = 1,
    Center,
    Right
}